<template>
  <div>
    <form @submit.prevent="login">
      <input type="text" placeholder="username" v-model="loginInfo.username" />
      <input type="password" placeholder="password" v-model="loginInfo.password" />
      <input type="submit" value="Login" />
    </form>
    <pre v-if="debug" v-show="result">{{ result }}</pre>
    <pre v-if="debug" v-show="Status.state">{{ Status }}</pre>
  </div>
</template>

<script>
import { API } from '@/yoteach2-gui/parts/index.js'

export default {
  props: {
    debug: {
      default () {
        return (window.UI_DEBUG || false)
      }
    }
  },
  data () {
    return {
      Status: API.Status,
      loginInfo: {
        username: '',
        password: ''
      },
      me: false,
      result: false
    }
  },
  methods: {
    login () {
      API.login(this.loginInfo)
        .then((resp) => {
          this.result = resp.data
        })
    },
    getMe () {
      API.me()
        .then((resp) => {
          this.me = resp.data
        })
    }
  },
  mounted () {
    if (this.debug) {
      this.getMe()
    }
  }
}
</script>

<style>

</style>
